<div class="table-row">
  <div class="table-item">{{ document.name }}</div>
  <div class="table-item hide-on-med-and-down">{{ document.clientName }}</div>
  <div class="table-item hide-on-med-and-down">{{ document.type }}</div>
  <div class="table-item hide-on-med-and-down">{{ document.created_at | date : 'dd/MM/yyyy HH:mm' }}</div>
  <div class="table-item hide-on-med-and-down">{{ document.numQuestions }}</div>
  <div class="table-item hide-on-med-and-down">{{ document.numCustomizations }}</div>
  <div class="table-item">
    <gl-button
      icon
      icon-center="glicon-edit"
      [routerLink]="['/documents', document.id]"
      class="right"
      *lmsProfileGuard="'documents.edit'"
      title="{{ 'actions.edit' | translate }} {{ document.name }}"
    >
    </gl-button>
    <gl-button
      icon
      icon-center="glicon-eye"
      [href]="getDocumentUrl()"
      target="_blank"
      class="right"
      title="{{ 'actions.edit' | translate }} {{ document.name }}"
    >
    </gl-button>
    <ng-content select="[row-actions]"></ng-content>
    <gl-button
      icon
      icon-center="glicon-down-arrow"
      (onClick)="details.toggleState()"
      class="right"
      title="{{ 'actions.showInfo' | translate }}"
      *lmsProfileGuard="'documents.row-detail'"
    >
    </gl-button>
  </div>
</div>
<lms-list-row-detail #details>
  <lms-documents-list-detail [document]="document"></lms-documents-list-detail>
</lms-list-row-detail>
